import { CommonModule } from '@angular/common';
import { DatiqGraphCardComponent } from './components/datiq-graph-card/datiq-graph-card.component';
import { DatiqLaneCardChartComponent } from './components/datiq-graph-card-chart/datiq-graph-card-chart.component';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { DatiqLoaderModule } from '@dat/datiq-components-pkg/loader';
import { DatiqGraphModule } from '@dat/datiq-components-pkg/graph';

const components = [DatiqGraphCardComponent, DatiqLaneCardChartComponent];

@NgModule({
    declarations: [...components],
    exports: [...components],
    imports: [CommonModule, MatIconModule, DatiqLoaderModule, DatiqGraphModule],
})
export class DatiqGraphCardModule {}
